import React from "react";
import * as S from "./../../styles";
export default function BottomContent(_ref) {
  var e = _ref.topLevelLinks,
      t = _ref.accountLinks,
      a = _ref.learnCategories,
      l = _ref.renderLinkAs,
      n = _ref.loggedIn,
      i = _ref.forBusinessesCategories,
      r = _ref.membership,
      c = _ref.membershipLink,
      s = _ref.membershipSubText,
      o = _ref.onLogout;
  return React.createElement(React.Fragment, null, e.learn ? React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
    "data-testid": "mobile-learn-heading"
  }, e.learn.label), Object.keys(a).map(function (e, t) {
    return React.createElement(S.MenuItem, {
      href: a[e].url,
      "data-testid": "mobile-learn-link-" + t,
      key: e,
      as: l || void 0
    }, e);
  })) : null, e.business ? React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
    "data-testid": "mobile-business-heading"
  }, e.business.label), Object.keys(i).map(function (e, t) {
    return React.createElement(S.MenuItem, {
      href: i[e].url,
      "data-testid": "mobile-business-link-" + t,
      key: e
    }, e);
  })) : null, e.support ? React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
    "data-testid": "mobile-support-heading"
  }, e.support.label), React.createElement(S.MenuItem, {
    href: e.support.url,
    "data-testid": "mobile-support-link"
  }, e.support.mobileSubcategoryLabel)) : null, n ? React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
    "data-testid": "mobile-account-heading"
  }, t.account.label), r ? React.createElement(S.MenuItem, {
    href: c(r),
    "data-testid": "mobile-membership-account-link",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "membership-account-link",
    "data-analytics-category": r.creditsAvailable > 0 ? "has-credits" : "no-credits",
    as: l || void 0
  }, t.account.membership.label, "!", React.createElement(S.MenuItemSubText, {
    "data-testid": "mobile-membership-account-text"
  }, s(r))) : null, React.createElement(S.MenuItem, {
    href: t.account.results.url,
    "data-testid": "mobile-results-link",
    as: l || void 0
  }, t.account.results.label), React.createElement(S.MenuItem, {
    href: t.account.settings.url,
    "data-testid": "mobile-settings-link",
    as: l || void 0
  }, t.account.settings.label), React.createElement(S.MenuItem, {
    href: t.account.logout.url,
    "data-testid": "mobile-logout-link",
    onClick: o,
    as: l || void 0
  }, t.account.logout.label)) : null);
}